import { useHtzWorkOrderShowQuery } from "@/services/backend/htz/work-order/api/work-order-api";
import { useCommitment } from "@/services/backend/relationships/hooks/use-commitment";
import { NullUUID } from "@bitory-gmbh/nidavellir";
import { useParams } from "react-router";
import { PositionsCard } from "../../../work-orders/[workOrderId]/positions/_components/positions-card";

export function PositionsRoute() {
  const { relationshipId, commitmentId } = useParams();
  const { data: commitment } = useCommitment(relationshipId!, commitmentId!);

  const { data } = useHtzWorkOrderShowQuery({
    id: commitment?.documentId || NullUUID,
  });

  if (!data) return null;

  return <PositionsCard workOrder={data} />;
}
